export default "__VITE_ASSET__Dd6T9oAt__"